<template>
  <header>
    <label class="lectureTimer" v-if="timerShow">{{ usedTime }}</label>
    <div class="controllerHeader">
      <div class="topHeader">
        <img src="@/assets/img/controller/logo_header.png" class="imgLogo" />
        <span class="txtTitle">{{ title }}</span>
        <span class="txtArea"> - {{ area }}</span>
        <img src="@/assets/img/controller/icon_account.png" class="imgAccount" @click="ShowAccountDialog" />
      </div>
      <div class="bottomHeader">
        <button class="lecture" :class="tabLectureClass" @click="LecturePage">{{ $t('Controller.TabLecture') }}</button>
        <button class="machine" :class="tabMachineClass" @click="MachinePage">{{ $t('Controller.TabMachine') }}</button>
      </div>
    </div>
    <DialogAccount
      :show="dialogAccoun.isShow"
      :title="dialogAccoun.title"
      :content="dialogAccoun.content"
      :logoutPath="logoutPath"
      @close-dialog="CloseDialog"
    />
  </header>
</template>
<script>
import DialogAccount from '@/components/Controller/DialogAccount.vue';
import '@/assets/scss/controllerResponsive.scss';

export default {
  name: 'Header',
  props: {
    title: String,
    logoutPath: String,
    tabShow: String,
    timerShow: Boolean,
  },
  data() {
    return {
      tabMachineClass: {},
      tabLectureClass: {},
      dialogAccoun: {
        isShow: false,
      },
      timer: null,
      usedTime: '',
      count: localStorage.getItem('usingTime'),
    };
  },
  mounted() {
    if (this.tabShow.toLowerCase() == 'machine') {
      this.tabLectureClass = { tabSelect: false, tabUnSelect: true };
      this.tabMachineClass = { tabSelect: true, tabUnSelect: false };
    } else {
      this.tabLectureClass = { tabSelect: true, tabUnSelect: false };
      this.tabMachineClass = { tabSelect: false, tabUnSelect: true };
    }
    if (this.timerShow) {
      this.usedTime = this.SecondToTime(this.count);
      this.StartTimer();
    }
    //for iOS
    window.scrollTo(0, 1);
    this.ChkAuth();
  },
  watch: {
    timerShow(bool) {
      if (bool) {
        this.usedTime = this.SecondToTime(this.count);
        this.StartTimer();
      } else {
        if (this.timer != null) clearInterval(this.timer);
      }
    },
    count(totalSec) {
      localStorage.setItem('usingTime', totalSec);
      this.usedTime = this.SecondToTime(totalSec);
    },
  },
  computed: {
    userName: function () {
      return this.$store.state.Profile.Name;
    },
    area: function () {
      return localStorage.getItem('county') + ' ' + localStorage.getItem('school');
    },
  },
  methods: {
    LecturePage() {
      let lectureName = localStorage.getItem('usingLecture');
      if (lectureName == '' || lectureName == null) {
        this.$router.push({ path: '/Controller/Lecture' });
      } else {
        if (this.$router.currentRoute.name != 'ControllerTheLecture') {
          this.$router.push({ path: '/Controller/TheLecture' });
        }
      }
    },
    MachinePage() {
      this.$router.push({ path: '/Controller/MachineManager' });
    },
    CloseDialog() {
      this.dialogAccoun.isShow = false;
    },
    ShowAccountDialog() {
      this.dialogAccoun.isShow = true;
    },
    StartTimer() {
      let vuethis = this;
      this.timer = setInterval(function () {
        vuethis.count++;
      }, 1000);
    },
    ChkAuth() {
      let vcmsAuth = localStorage.getItem('vcms');
      if (vcmsAuth == 'false') {
        this.$toasted.show('此帳號無vcms權限，請確認。', {
          icon: 'warning',
          position: 'bottom-center',
          duration: 2500,
        });
        this.$store.dispatch('LOGOUT');
      }
    },
  },
  components: {
    DialogAccount,
  },
};
</script>

